import { openOrderSuccessModal } from './active_modal';
import { getCustomerPaymentMethods } from './payment_methods';
import { clearBraintreeFailure } from './braintree_failure';
import { setLastOrderCart } from './last_order_cart';
import { setComputedCart, removePromoFromCart } from './computed_cart';
import { saveEnrollCartCookie } from './cart_actions';
import { getEnrollCartProductIds, deleteCookie } from '../shared/cookie.js';
import { setCustomer } from './customer';
import { clearUpgradeStatus } from './upgrade_status';
import { setFeedback, delayedClearFeedback } from './feedback';
import { clearCreditAcceptState } from './credit_accept_state';
import { setCreditViewDefault } from './credit_view';
import { fireCartError, clearCartError } from './cart_error';
import { firePreorderMessage, clearPreorderMessage } from './preorder_message';
import { setEbookOrderFailure, setEbookOrderSuccess } from './ebook_order_success';

import request from 'superagent';

const MERCHANT_ID = '61119';

function setPurchaseGA(res, store) {
  let order = res.body.order_history[0],
      order_items = order.items.map( item => {
        return {
          'name':   item.title,
          'mmid':   item.mmid,
          'price':  item.price,
          'quantity':item.quantity
        }
      }),
      coupon = order.promo_id;

  window.dataLayer.push({
      'ecommerce': {
          'purchase': {
              'actionField': {
                  'id': 'order-' + store.tla.toUpperCase() + order.id,
                  'revenue': order.grand_total.toString(),
                  'tax': order.tax_amount.toString(),
                  'shipping': order.shipping_amount.toString(),
                  'coupon': coupon ? coupon : ''
              },
              'products': order_items
          }
      }
  });
  // This needs to happen to force ecommerce event to go to GA
  window.dataLayer.push({event: 'pageview', url: window.location.hostname + window.location.pathname, logged_in: true});
}

// need to replace getEnrollCartProductIds() and addPixel
export function placeEnrollOrder(nonce, token, failFunction) {
  return (dispatch, getState) => {
    let newCustomer = getState().customer.fulfillment_type === "Negative";
    request
      .put('/svc/cart/checkout/enroll/')
      .send({
        paymentMethodNonce: nonce,
        token: token,
        cart: getEnrollCartProductIds()
      })
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200){
          failFunction();
          if(res.body){
            dispatch(setCustomer(res.body));
            saveEnrollCartCookie(res.body.cart);
            let newEnrollCart = getEnrollCartProductIds();
            newEnrollCart.forEach((n, i) => {
              if (n) newEnrollCart[i] = new Map(new Map(getState().maps).get('productMap')).get(n.id);
            });
            dispatch( setComputedCart(res.body, getState().computedCart, newEnrollCart));
          }
          return dispatch( fireCartError( err ? err.message : res.statusText ));
        }
        let order = res.body.order_history[0];
        window.dataLayer.push({ 'event': 'enroll'});
        setPurchaseGA(res, getState().store );
        deleteCookie('enrollCart'); // go away, enroll cart, we don't need you anymore

        return dispatch([
          setLastOrderCart(getState().computedCart),
          openOrderSuccessModal(),
          clearUpgradeStatus(),
          clearCartError(),
          clearBraintreeFailure(),
          setCustomer(res.body),
          clearCreditAcceptState(),
          setCreditViewDefault(),
          setComputedCart( res.body, getState().computedCart, [])
        ]);
      });
  }
}

export function placeOrder(nonce, token, finalFunction) {
  return (dispatch, getState) => {
    let computedCart = getState().computedCart;
    let aOrderCredits = computedCart.credits_applied;
    let minifiedCart = getState().customer.cart
      .map( x => x ? {id: x.id, format: x.format, quantity: x.quantity } : null );
    let oPromo = computedCart.promo || null;

    request
      .put('/svc/cart/checkout/')
      .send({
        paymentMethodNonce: nonce,
        token: token,
        creditsApplied: aOrderCredits,
        cart: minifiedCart,
        promoCode: (oPromo) ? oPromo.promo_code : null
      })
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200){
          finalFunction();
          return dispatch([
            fireCartError( err ? err.message : res.statusText ),
            setCustomer(res.body),
            setComputedCart(res.body, computedCart, []),
          ]);
        }

        setPurchaseGA(res, getState().store);

        return dispatch([
          setLastOrderCart(computedCart),
          openOrderSuccessModal(),
          clearCartError(),
          clearBraintreeFailure(),
          setCustomer(res.body),
          setComputedCart(res.body, computedCart, []),
          removePromoFromCart()
        ]);
      });
  }
}


export function placeEbookOrder(nonce, token, failFunction, nMMIDobj) {
  return (dispatch, getState) => {
    request
      .get('/svc/cart/checkout/ebook/' + nMMIDobj.mmid + '/' + nonce + '/' + token )
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
          failFunction();
          return dispatch( setEbookOrderFailure());
        }

        setPurchaseGA(res, getState().store);

        return dispatch([
          setEbookOrderSuccess(),
          clearBraintreeFailure(),
          setCustomer(res.body )
        ]);
      });
  }
}


export function placePreorder(nonce, token, failFunction, nMMIDobj) {
  return (dispatch, getState) => {
    request
      .get('/svc/cart/checkout/preorder/' + nMMIDobj.mmid + '/' + nMMIDobj.format + '/' + nonce + '/' + token + '/' + nMMIDobj.credit)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200 ){
          failFunction();
          return dispatch(firePreorderMessage({
            type: 'error',
            text: err.message ? err.message : res.statusText
          }));
        } else {
          setPurchaseGA(res, getState().store);

          return dispatch([
            firePreorderMessage({
              type: 'success'
            }),
            clearBraintreeFailure(),
            setCustomer(res.body )
          ]);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/modules/order_actions.js